import React, { useState, useEffect } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import { connect } from 'react-redux'
import { DatePicker, Select, Button } from 'antd'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core/selectors'
import * as api from '../../../api/pgads'
import CommonScreen from '../CommonScreen'
import R from 'ramda'
const title = 'User Message Category'

const UserMessageCategory = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [users, setUsers] = useState([])
  const [categoryList, setCategoryList] = useState([])

  useEffect(() => {
    api
      .getUsers(apiTargetInfo)()
      .fork(console.log, data => {
        const sortByNameCaseInsensitive = R.sortBy(
          R.compose(R.toLower, R.prop('firstName'))
        )
        const dd = sortByNameCaseInsensitive(
          data.map(d => ({
            ...d,
            firstName: d.firstName || d.userName,
            lastName: d.lastName || d.userName,
          }))
        )

        setUsers(dd)
      })
    api
      .getMessageCategory(apiTargetInfo)
      .fork(console.log, data => setCategoryList(data))
  }, [apiTargetInfo])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '20px',
        }}
      >
        Effective Date :{' '}
      </div>
      <DatePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={insertData.effectiveDateMom}
        onChange={date => {
          setInsertData({
            ...insertData,
            effectiveDateMom: date,
            effectiveDate: date.format('YYYY-MM-DD'),
          })
        }}
      />
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        User Name :
      </div>
      <Select
        style={{ width: '200px' }}
        value={insertData.username}
        onChange={e => setInsertData({ ...insertData, username: e })}
        showSearch
      >
        {users.map(u => (
          <Select.Option key={u.userName}>
            {u.firstName || u.userName} {u.lastName}
          </Select.Option>
        ))}
      </Select>
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        Category :
      </div>
      <Select
        style={{ width: '200px' }}
        value={insertData.category}
        onChange={e => setInsertData({ ...insertData, category: e })}
      >
        {categoryList.map(({ category }) => (
          <Select.Option key={category}>{category}</Select.Option>
        ))}
      </Select>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={UserMessageCategoryHeaders}
      saveTask={api.saveUserMessageCategory}
      retrieveTask={api.getUserMessageCategory}
      deleteTask={api.deleteUserMessageCategory}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={UserMessageCategoryHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(UserMessageCategory)

export const UserMessageCategoryHeaders = [
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'username',
    display: 'User Name',
    isKey: true,
  }),
  strCol({
    ident: 'category',
    display: 'Category',
    isKey: true,
    width: 200,
    alignment: 'left',
  }),
  modifierCol,
  modifiedDateCol,
]
